import { render, staticRenderFns } from "./create-or-edit-team-settings.vue?vue&type=template&id=25ed33db"
import script from "./create-or-edit-team-settings.ts?vue&type=script&lang=js&external"
export * from "./create-or-edit-team-settings.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports